import React, { useState, useEffect, useRef } from 'react';
import { Link, Prompt } from 'react-router-dom';

import { Slider } from 'react-semantic-ui-range';
import dayjs from 'dayjs';
import useInterval from 'react-useinterval';

import { addColon, program_sch, secToTimeStr } from '../common/common_fnc';
import { schduleList, programDetail } from '../../../network/apis/apiUri';

import useAxios from '../../../network/useAxios';
import NavData from '../../../config/data/nav/nav_data.json';
import './css/common_radio.scss';
import * as URL from '../../../constant/kollusUrl';

function CommonRadio({ isRadioPlay, setIsRadioPlay, mode }) {
  const nav = NavData;
  const listenPlayer = useRef();

  const [controller, setController] = useState({
    playing: false,
    loaded: false,
    loop: false,
    mute: false,
    volume: 5,
    seek: 0.1,
    rate: 1,
    isSeeking: false,
  });

  const settings = {
    start: 5,
    min: 0,
    max: 10,
    step: 1,
    onChange: (e) => {
      handleVolume(e / 10);
    },
  };

  const postData = {
    address: 'https://script.arirang.com/api/v1/bis/listScheduleV3.do',
    method: 'POST',
    headers: {},
    body: {
      data: {
        dmParam: {
          chanId: 'CH_R',
          broadYmd: dayjs.tz().format('YYYYMMDD'),
          planNo: '1',
        },
      },
    },
  };
  // 내일 데이터
  const tmrData = {
    address: 'https://script.arirang.com/api/v1/bis/listScheduleV3.do',
    method: 'POST',
    headers: {},
    body: {
      data: {
        dmParam: {
          chanId: 'CH_R',
          broadYmd: dayjs.tz().add(1, 'd').format('YYYYMMDD'),
          planNo: '1',
        },
      },
    },
  };

  const [scheduleList, scheduleRefetch] = useAxios(schduleList, [], postData, true);
  const { data: scheduleData } = scheduleList;

  const [tmrScheduleList, tmrScheduleRefetch] = useAxios(schduleList, [], tmrData, true);
  const { data: tmrSchData } = tmrScheduleList;

  const [liveItem, liveRefetch] = useAxios(programDetail, [], {}, false);
  const { data: liveData } = liveItem;

  const [nowSchedule, setNowSchedule] = useState({});

  const listenOnload = () => {
    const listenController = new window.VgControllerClient({
      target_window: document.getElementById(`listenChild`).contentWindow,
    });
    listenController.pause();

    setIsRadioPlay({ ...isRadioPlay, footerRef: listenController });
  };

  const playerOnload = (idx, id) => {
    const OnloadController = new window.VgControllerClient({
      target_window: document.getElementById(`aodChild`).contentWindow,
    });

    setIsRadioPlay((prev) => ({ ...prev, aodController: [OnloadController, id] }));

    OnloadController.on('done', function () {
      if (isRadioPlay.aodData.length - 1 === isRadioPlay.contentKey[1]) {
        isRadioPlay.setPodcastDetailId(isRadioPlay.aodData[0].vod_id);
        setIsRadioPlay((prev) => ({
          ...prev,
          footerPlayed: true,
          radioPlayed: false,
          contentKey: [prev.aodData[0].media_content_key, 0, prev.aodData[0].vod_id],
          aod: [
            prev.aodData[0].vod_id,
            prev.aodData[0].vod_title,
            prev.aodData[0].image_url,
            prev.aodData[0].reg_date?.substr(0, 10),
            prev.aodData[0].media_content_key,
          ],
          aodData: prev.aodData,
        }));
      } else {
        isRadioPlay.setPodcastDetailId(isRadioPlay.aodData[isRadioPlay.contentKey[1] + 1].vod_id);
        setIsRadioPlay((prev) => ({
          ...prev,
          footerPlayed: true,
          radioPlayed: false,
          contentKey: [
            prev.aodData[prev.contentKey[1] + 1].media_content_key,
            prev.contentKey[1] + 1,
            prev.aodData[prev.contentKey[1] + 1].vod_id,
          ],
          aod: [
            prev.aodData[prev.contentKey[1] + 1].vod_id,
            prev.aodData[prev.contentKey[1] + 1].vod_title,
            prev.aodData[prev.contentKey[1] + 1].image_url,
            prev.aodData[prev.contentKey[1] + 1].reg_date?.substr(0, 10),
            prev.aodData[prev.contentKey[1] + 1].media_content_key,
          ],
          aodData: prev.aodData,
        }));
      }
    });
  };

  const handlePrompt = (location) => {
    let pathname = location.pathname.split('/')[1];
    if (pathname === '' || pathname !== 'radio') {
      setIsRadioPlay({
        watch: false,
        radioPlayed: false,
        podcastPlayed: false,
        footerPlayed: false,
        footerRef: {},
        vod: false,
        aod: [],
        aodController: [],
        contentKey: [],
        footerAudioUrl: URL.LIVE_RADIO,
        playPercent: 0,
        playPosition: 0,
        playDuration: 0,
      });
    }
  };

  // 하단플레이어 버튼
  const handleToggle = (e) => {
    //하단플레이어 정지중
    if (!isRadioPlay.footerPlayed) {
      // watch now 재생중
      if (isRadioPlay.watch) {
        isRadioPlay.watchRef.pause();
        // 플레이어 aod 체크
        if (isRadioPlay.aod.length !== 0) {
          isRadioPlay.aodController[0].play();
          setIsRadioPlay((prev) => ({
            ...prev,
            footerPlayed: true,
            watch: false,
            vod: false,
            podcastPlayed: true,
          }));
        } else {
          isRadioPlay.footerRef.play();
          setIsRadioPlay({
            ...isRadioPlay,
            footerPlayed: true,
            watch: false,
          });
        }
        // 비디오 재생중
      } else if (isRadioPlay.vod) {
        isRadioPlay.vodRef.pause();
        // 플레이어 aod 체크
        if (isRadioPlay.aod.length !== 0) {
          isRadioPlay.aodController[0].play();
          isRadioPlay.aod[0] = isRadioPlay.aodController[1];
          setIsRadioPlay((prev) => ({
            ...prev,
            footerPlayed: true,
            watch: false,
            vod: false,
            podcastPlayed: true,
          }));
        } else {
          isRadioPlay.footerRef.play();

          setIsRadioPlay((prev) => ({
            ...prev,
            // footerRef: hlsPlayerRef,
            footerPlayed: true,
            watch: false,
            vod: false,
            radioPlayed: true,
          }));
        }
      } else {
        // 하단플레이어 aod 등록중
        if (isRadioPlay.aod.length !== 0) {
          // hlsPlayerRef.current?.pause();
          isRadioPlay.aodController[0].play();
          isRadioPlay.aod[0] = isRadioPlay.aodController[1];
          setIsRadioPlay((prev) => ({
            ...prev,
            // footerRef: hlsPlayerRef,
            footerPlayed: !isRadioPlay.footerPlayed,
            watch: false,
            vod: false,
            podcastPlayed: true,
          }));
        } else {
          // 하단플레이어 listen noew
          isRadioPlay.footerRef?.play();
          setIsRadioPlay((prev) => ({
            ...prev,
            footerPlayed: !isRadioPlay.footerPlayed,
            watch: false,
            vod: false,
            radioPlayed: true,
          }));
        }
      }
      // 하단플레이어 재생중
    } else {
      // 플레이어 aod 체크
      if (isRadioPlay.aod.length !== 0) {
        isRadioPlay.aodController[0].pause();
        isRadioPlay.aod[0] = -1;
        setIsRadioPlay((prev) => ({ ...prev, podcastPlayed: false, footerPlayed: false }));
      } else {
        isRadioPlay.footerRef.pause();
        setIsRadioPlay({ ...isRadioPlay, radioPlayed: false, footerPlayed: false });
      }
    }
  };
  // volume
  const handleVolume = (e) => {
    isRadioPlay.aodController?.[0]?.set_volume(e * 100);
    isRadioPlay.footerRef?.set_volume(e * 100);
    setController((prev) => {
      return { ...prev, volume: e * 10 };
    });
  };
  // mute
  const handleMute = (e) => {
    isRadioPlay.aodController?.[0]?.mute();
    isRadioPlay.footerRef?.mute();
    setController((prev) => {
      return { ...prev, mute: !prev.mute };
    });
  };
  // seek
  const handleSeekingChange = (e) => {
    isRadioPlay?.aodController?.[0]?.set_current_time(Math.floor((isRadioPlay?.playDuration / 100) * e.target.value));
    setController((prev) => {
      return { ...prev, seek: parseFloat(e.target.value) };
    });
  };

  const handleSecond = (sort) => {
    if (sort === 'back') {
      isRadioPlay.aodController[0].rw();
    } else {
      isRadioPlay.aodController[0].ff();
    }
  };
  const handleMove = (sort) => {
    if (sort === 'back') {
      if (isRadioPlay.aodData.length - isRadioPlay.aodData.length === isRadioPlay.contentKey[1]) {
        if (isRadioPlay.setPodcastDetailId)
          isRadioPlay.setPodcastDetailId(isRadioPlay.aodData[isRadioPlay.aodData.length - 1].vod_id);
        setIsRadioPlay((prev) => ({
          ...prev,
          footerPlayed: true,
          radioPlayed: false,
          contentKey: [
            prev.aodData[isRadioPlay.aodData.length - 1].media_content_key,
            isRadioPlay.aodData.length - 1,
            prev.aodData[isRadioPlay.aodData.length - 1].vod_id,
          ],
          aod: [
            prev.aodData[isRadioPlay.aodData.length - 1].vod_id,
            prev.aodData[isRadioPlay.aodData.length - 1].vod_title,
            prev.aodData[isRadioPlay.aodData.length - 1].image_url,
            prev.aodData[isRadioPlay.aodData.length - 1].reg_date?.substr(0, 10),
            prev.aodData[isRadioPlay.aodData.length - 1].media_content_key,
          ],
          aodData: prev.aodData,
        }));
      } else {
        if (isRadioPlay.setPodcastDetailId)
          isRadioPlay.setPodcastDetailId(isRadioPlay.aodData[isRadioPlay.contentKey[1] - 1].vod_id);
        setIsRadioPlay((prev) => ({
          ...prev,
          footerPlayed: true,
          radioPlayed: false,
          contentKey: [
            prev.aodData[prev.contentKey[1] - 1].media_content_key,
            prev.contentKey[1] - 1,
            prev.aodData[prev.contentKey[1] - 1].vod_id,
          ],
          aod: [
            prev.aodData[prev.contentKey[1] - 1].vod_id,
            prev.aodData[prev.contentKey[1] - 1].vod_title,
            prev.aodData[prev.contentKey[1] - 1].image_url,
            prev.aodData[prev.contentKey[1] - 1].reg_date?.substr(0, 10),
            prev.aodData[prev.contentKey[1] - 1].media_content_key,
          ],
          aodData: prev.aodData,
        }));
      }
    } else {
      if (isRadioPlay.aodData.length - 1 === isRadioPlay.contentKey[1]) {
        if (isRadioPlay.setPodcastDetailId) isRadioPlay.setPodcastDetailId(isRadioPlay.aodData[0].vod_id);
        setIsRadioPlay((prev) => ({
          ...prev,
          footerPlayed: true,
          radioPlayed: false,
          contentKey: [prev.aodData[0].media_content_key, 0, prev.aodData[0].vod_id],
          aod: [
            prev.aodData[0].vod_id,
            prev.aodData[0].vod_title,
            prev.aodData[0].image_url,
            prev.aodData[0].reg_date?.substr(0, 10),
            prev.aodData[0].media_content_key,
          ],
          aodData: prev.aodData,
        }));
      } else {
        if (isRadioPlay.setPodcastDetailId)
          isRadioPlay.setPodcastDetailId(isRadioPlay.aodData[isRadioPlay.contentKey[1] + 1].vod_id);
        setIsRadioPlay((prev) => ({
          ...prev,
          footerPlayed: true,
          radioPlayed: false,
          contentKey: [
            prev.aodData[prev.contentKey[1] + 1].media_content_key,
            prev.contentKey[1] + 1,
            prev.aodData[prev.contentKey[1] + 1].vod_id,
          ],
          aod: [
            prev.aodData[prev.contentKey[1] + 1].vod_id,
            prev.aodData[prev.contentKey[1] + 1].vod_title,
            prev.aodData[prev.contentKey[1] + 1].image_url,
            prev.aodData[prev.contentKey[1] + 1].reg_date?.substr(0, 10),
            prev.aodData[prev.contentKey[1] + 1].media_content_key,
          ],
          aodData: prev.aodData,
        }));
      }
    }
  };

  useEffect(() => {
    setNowSchedule(program_sch(scheduleData, tmrSchData));
  }, [scheduleData, tmrSchData]);

  useEffect(() => {
    if (nowSchedule) {
      if (Object.keys(nowSchedule).length !== 0) {
        liveRefetch({ bis_program_code: nowSchedule?.now?.pgmCd });
      }
    }
  }, [nowSchedule]);

  useEffect(() => {
    if (isRadioPlay.aodController.length !== 0) {
      isRadioPlay.aodController?.[0]
        ?.on('progress', function (percent, position, duration) {
          setIsRadioPlay((prev) => ({
            ...prev,
            playPercent: percent,
            playPosition: Math.floor(position),
            playDuration: Math.floor(duration),
          }));
        })
        .on('ready', () => {
          isRadioPlay.aodController?.[0].play();
          isRadioPlay.aodController?.[0].set_volume(controller.volume * 10);
          Object.keys(isRadioPlay.footerRef).length && isRadioPlay.footerRef?.pause();
        })
        .on('loaded', () => {
          isRadioPlay.aodController?.[0].set_jumpstep(15);
        });
    }
  }, [isRadioPlay.aodController]);

  useInterval(() => {
    if (dayjs.tz().format('HHmm') === nowSchedule?.next?.broadHm) {
      scheduleRefetch(postData);
      tmrScheduleRefetch({
        ...postData,
        body: {
          data: { dmParam: { ...postData.body.data.dmParam, broadYmd: dayjs.tz().add(1, 'd').format('YYYYMMDD') } },
        },
      });
    }
  }, 3000);

  return (
    <div id="CommonRadio" className="CommonRadio">
      <Prompt when={true} message={handlePrompt} />
      <div className="CommonRadio_content">
        {isRadioPlay.aod[0] && (
          <iframe
            id={`aodChild`}
            title="arirangRadio"
            className="aodContent"
            src={`https://v.kr.kollus.com/${isRadioPlay.contentKey[0]}?cdn=arirang-dd`}
            allowFullScreen
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            key={`${isRadioPlay.contentKey[2]}${isRadioPlay.contentKey[1]}`}
            onLoad={() => playerOnload(isRadioPlay.contentKey[1], isRadioPlay.contentKey[2])}
          />
        )}
        <iframe
          ref={listenPlayer}
          id={`listenChild`}
          title="listenContent"
          className="listenContent"
          src={isRadioPlay.footerAudioUrl}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          key={`isRadioPlay.footerAudioUrl`}
          onLoad={() => listenOnload()}
        />

        <div className="CommonRadio_content_album">
          <Link
            to={
              isRadioPlay.aod.length !== 0
                ? `${nav['RADIO_MAIN'].path}/podcast/episode/${isRadioPlay.aod?.[4]}`
                : `${nav['RADIO_MAIN'].path}/${liveData?.program_id}`
            }
            className="albumImg"
          >
            <img
              className="img"
              src={isRadioPlay.aod.length !== 0 ? isRadioPlay.aod?.[2] : liveData?.image?.[4]?.url}
              alt={
                isRadioPlay.aod.length !== 0
                  ? isRadioPlay.aod[1]
                  : mode === 'en'
                  ? liveData?.title?.[0]?.text
                  : liveData?.title?.[1]?.text
              }
            />
          </Link>
          <div className="albumTitle">
            <h2 className="title">
              {isRadioPlay.aod.length !== 0
                ? isRadioPlay.aod[1]
                : mode === 'en'
                ? liveData?.title?.[0]?.text
                : liveData?.title?.[1]?.text}
            </h2>
            <div className="info">
              <div className="info_time">
                {isRadioPlay.aod.length !== 0
                  ? isRadioPlay.aod[3]
                  : `${addColon(nowSchedule?.now?.broadHm)} ~ ${addColon(nowSchedule?.next?.broadHm)} KST`}
              </div>
              <div className="info_vol">
                <button
                  type="button"
                  onClick={handleMute}
                  className={`info_vol_img ${controller.volume === 0 ? 'ico_volume-none' : ''} ${
                    controller.volume > 0 && controller.volume <= 4 ? 'ico_volume-half' : ''
                  } ${controller.volume > 4 && controller.volume <= 10 ? 'ico_volume' : ''} ${
                    controller.mute ? 'ico_mute' : ''
                  }`}
                >
                  <span className="sr-only">{controller.volume === 0 ? '소리 켜기' : '소리 끄기'}</span>
                </button>
                <div className="info_vol_range">
                  <Slider
                    value={controller.volume}
                    style={{
                      track: { backgroundColor: '#B2B2B2' },
                      thumb: { backgroundColor: 'transparent', boxShadow: 'none' },
                    }}
                    color="#1b1b1b"
                    settings={settings}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="CommonRadio_content_player">
          <div className="btnPlayer">
            {isRadioPlay.aod.length !== 0 && (
              <>
                <button
                  type="button"
                  className="button btnPrev"
                  onClick={() => {
                    handleMove('back');
                  }}
                >
                  <span className="sr-only">이전으로</span>
                </button>
                <button
                  type="button"
                  className="button btnSecPrev"
                  onClick={() => {
                    handleSecond('back');
                  }}
                >
                  <span className="sr-only">15초 이전으로</span>
                </button>
              </>
            )}

            <button
              type="button"
              className={`button style_margin ${!isRadioPlay.footerPlayed ? 'btnPlay' : 'btnPause'}`}
              onClick={() => handleToggle()}
            >
              <span className="sr-only">{controller.playing ? '재생하기' : '정지하기'}</span>
            </button>
            {isRadioPlay.aod.length !== 0 && (
              <>
                <button
                  type="button"
                  className="button btnSecNext"
                  onClick={() => {
                    handleSecond('next');
                  }}
                >
                  <span className="sr-only">15초 다음으로</span>
                </button>
                <button
                  type="button"
                  className="button btnNext"
                  onClick={() => {
                    handleMove('next');
                  }}
                >
                  <span className="sr-only">다음으로</span>
                </button>
              </>
            )}
          </div>
          {isRadioPlay.aod.length !== 0 && (
            <div className="btnPlayerBar">
              <span className="btnPlayerBar_sec current-time">
                {isRadioPlay.playPosition ? secToTimeStr(isRadioPlay.playPosition) : `00:00`}
              </span>
              <div className="btnPlayerBar_progress">
                <input
                  type="range"
                  name="inputSeek"
                  id="inputSeek"
                  className="inputSeek"
                  step="0.01"
                  value={isRadioPlay.playDuration ? isRadioPlay.playPercent : 0.01}
                  onChange={(e) => handleSeekingChange(e)}
                />
              </div>
              <span className="btnPlayerBar_sec total-time">
                {isRadioPlay.playDuration ? secToTimeStr(isRadioPlay.playDuration) : `00:00`}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default CommonRadio;
